import { Component, OnInit } from '@angular/core';

import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';

@Component({
  selector: 'app-choose-location-page',
  templateUrl: './choose-location-page.component.html',
  styleUrls: ['./choose-location-page.component.scss']
})
export class ChooseLocationPageComponent implements OnInit {

  locationHasBeenSelected:boolean;
  selectedLocationTitlte:string;

  availableLocations:AvailableLocation[] = [
    {locationTitle:"Ajax", restaurants:[{regionId:"ajax",clientId:"110ritchie", title:"Highway 401 & Westney Rd. S"}]},
    {locationTitle:"Aurora", restaurants:[{regionId:"aurora",clientId:"brooklandyonge", title:"Brookland & Yonge"}]},
    {locationTitle:"Barrie", restaurants:[{regionId:"barrie",clientId:"555mapleview", title:"555 Mapleview Drive West"}]},
    {locationTitle:"Bradford", restaurants:[{regionId:"bradford",clientId:"hollandbarrie", title:"Holland St E & Barrie St"}]},
    {locationTitle:"Oshawa", restaurants:[{regionId:"oshawa",clientId:"bondsimcoe", title:"Bond St & Simcoe"}]},
    {locationTitle:"Ottawa", restaurants:[{regionId:"ottawa",clientId:"mcarthur", title:"411 McArthur Ave & Vanier"}]},
    {locationTitle:"Richmond Hill", restaurants:[{regionId:"richmondhill",clientId:"yonge", title:"10520 Yonge Street"}]},
    {locationTitle:"Thornhill", restaurants:[{regionId:"thornhill",clientId:"yongeclark", title:"Yonge & Clark"}]},

    {locationTitle:"Port Hope", restaurants:[
      {regionId:"porthope",clientId:"401toronto", title:"135 Toronto Road"},
    ]},

    {locationTitle:"Markham", restaurants:[
      {regionId:"markham",clientId:"hwy48and16", title:"Highway 48 & 16th"},
      {regionId:"markham", clientId:"brimleyfinch", title:"Brimley and Finch"}
    ]},

    {locationTitle:"Toronto", restaurants:[
      {regionId:"toronto",clientId:"danforthaugust", title:"Danforth & August"},
      {regionId:"toronto", clientId:"finchpharmacy", title:"Finch & Pharmacy"},
      {regionId:"toronto", clientId:"keelefinch", title:"Keele & Finch"},
      {regionId:"toronto", clientId:"morningsidee", title:"Morningside & 401"}
    ]}
  ];

  availableRestaurants:AvailableRestaurants[]; 



  constructor(private avantoRoute:AvantoRoutingService) { }

  ngOnInit() {
    window.location.replace("/website/");
    this.locationHasBeenSelected = false;
  }

  selectLocation(locationIndex){
    this.availableRestaurants = this.availableLocations[locationIndex].restaurants;
    this.selectedLocationTitlte = this.availableLocations[locationIndex].locationTitle;
    this.locationHasBeenSelected = true;
  }

  showAllLocations(){
    this.locationHasBeenSelected = false;
  }

  selectRestaurant(restaurantIndex){
    const selectedRestaurant = this.availableRestaurants[restaurantIndex];
    this.goToLocation(selectedRestaurant.regionId,selectedRestaurant.clientId)
  }

  goToLocation(regionId,clientId){
    this.avantoRoute.goToChooseFoodPage(regionId,clientId);
  }
}

export class AvailableLocation{
  locationTitle:string;
  restaurants:AvailableRestaurants[]
}
export class AvailableRestaurants{
  regionId:string;
  clientId:string;
  title:string;
}